import { Icon } from '@iconify/react';
import { useTranslation } from 'react-i18next';



const ConverseDisclaimer = (props: { showDisclaimer: boolean }) => {
    const { t } = useTranslation();
    return (
        (props.showDisclaimer && <div className="flex items-center justify-center text-xs text-default-400 gap-2 pt-2">
            <Icon icon="solar:danger-triangle-bold-duotone" width="18" height="18" />
            <p>
                {t('Advisor responses may not always be accurate or up-to-date. Please verify and use with caution.')}
            </p>
        </div>)
    )
}

export default ConverseDisclaimer